type UILang = "en" | "he";

const COUNTRY_TO_LANG: Record<string, UILang> = {
    IL: "he",
};

export function detectUILangSync(): UILang {
    const langs = (navigator.languages?.length ? navigator.languages : [navigator.language]) as string[];
    if (langs.some((l) => l.toLowerCase().startsWith("he"))) return "he";
    return "en";
}

export async function detectUILangAsync(): Promise<UILang> {
    const sync = detectUILangSync();
    if (sync !== "en") return sync;
    try {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 3000);
        const res = await fetch("https://ipapi.co/country/", { signal: controller.signal });
        clearTimeout(timeout);
        const country = (await res.text()).trim().toUpperCase();
        if (COUNTRY_TO_LANG[country]) return COUNTRY_TO_LANG[country];
    } catch {}
    return "en";
}
